export const REQUEST_SETTLEMENTS = 'REQUEST_SETTLEMENTS';
export const RECEIVE_SETTLEMENTS = 'RECEIVE_SETTLEMENTS';
export const HIDE_TEMPORARY_SETTLEMENT_BANNER =
  'HIDE_TEMPORARY_SETTLEMENT_BANNER';
